<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.sociogram_surveys', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    <span class="text-gray-700">{{ $t('messages.sociogram_survey_form_step_dates') }}</span>
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.published_at')" for="opened_at" />
                            <FormInput
                                id="opened_at"
                                v-model="form.opened_at"
                                name="opened_at"
                                type="datetime-local"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.opened_at" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.unpublished_at')" for="closed_at" />
                            <FormInput
                                id="closed_at"
                                v-model="form.closed_at"
                                name="closed_at"
                                type="datetime-local"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.closed_at" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'sociogramSurvey'],
    data() {
        return {
            form: this.$inertia.form({
                opened_at: this.sociogramSurvey.opened_at,
                closed_at: this.sociogramSurvey.closed_at,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
